import BaseModel from './BaseModel';
export default class FareRule extends BaseModel {
    constructor(data = {}) {
        super(data);
        this.setData(data)
    }

    setData(data = this.__data__) {
        this.id = data.id;
        this.airlineCode = data.airlineCode || this.translate.airlineCode || undefined;
        this.className = data.className || this.translate.className || undefined;
        this.cancellationRefund = data.cancellationRefund || this.translate.cancellationRefund || undefined;
        this.itineraryChange = data.itineraryChange || this.translate.itineraryChange || undefined;
        this.timeChange = data.timeChange || this.translate.timeChange || undefined;
        this.passengerInfoChange = data.passengerInfoChange || this.translate.passengerInfoChange || undefined;
        this.remarks = data.remarks || this.translate.remarks || undefined;
        this.createdDate = data.createdDate || undefined
    }

    export(hasTranslate = false) {
        const result = super.export({
            id: this.id,
            airlineCode: this.airlineCode,
            className: this.className,
            cancellationRefund: this.cancellationRefund,
            itineraryChange: this.itineraryChange,
            timeChange: this.timeChange,
            passengerInfoChange: this.passengerInfoChange,
            remarks: this.remarks
        });
        if (hasTranslate) result.translate = () => {
            return {
                id: this.translate.id || this.id,
                fareRuleId: this.translate.fareRuleId || this.id,
                cancellationRefund: this.cancellationRefund,
                timeChange: this.timeChange,
                itineraryChange: this.itineraryChange,
                passengerInfoChange: this.passengerInfoChange,
                remarks: this.remarks,
                languageCode: this.languageCode,
            }
        }
        return result;
    }

}
